import { defineStore } from 'pinia'
import router from '@/router'

const DEFAULT_MESSAGE = 'ページが見つかりませんでした。'

export const useErrorStore = defineStore({
  id: 'error',
  state: () => ({
    /** エラーメッセージ */
    message: DEFAULT_MESSAGE,
  }),
  getters: {},
  actions: {
    /**
     * エラーページへ遷移する
     *
     * ページ遷移後に非同期でメッセージが設定される。
     */
    async go(message?: string) {
      await router.replace('/error').then(() => {
        message && (this.message = message)
      })
    },
    /**
     * エラーメッセージをリセットする
     *
     * ルーターの`beforeEach`で毎回リセットをするのを忘れないようにすること。
     */
    reset() {
      this.message = DEFAULT_MESSAGE
    },
  },
})
